import { useLocale } from "@/shared/i18n";
import {
  DatePickerProps as AntdDatePickerProps,
  DatePicker as AntdDatePicker,
} from "antd";
import { twMerge } from "tailwind-merge";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../constants/formats";

export type DatePickerProps = AntdDatePickerProps;

export function DatePicker({ className, showTime, ...props }: DatePickerProps) {
  const { locale } = useLocale();
  const format = showTime ? DATE_TIME_FORMAT[locale] : DATE_FORMAT[locale];

  return (
    <AntdDatePicker
      className={twMerge("!w-full", className)}
      showSecond={false}
      format={{
        format,
        type: "mask",
      }}
      showTime={showTime}
      {...props}
    />
  );
}
